import { Stack } from "@mantine/core"

import { CommunicationStudioClasses } from "@tfg/types/constants/communication-studio.constant"
import {
  logoAlignCSSVariable,
  paddingInlineCSSVariable,
} from "@tfg/types/schemas/communication-studio/cssVariables"
import { FormFileType } from "@tfg/types/schemas/file"

import { DesignStudioParametersToolkit } from "../utils/designStudioParametersToolkit"

export const Logo = ({
  companyName,
  logoFile,
}: {
  companyName: string
  logoFile?: FormFileType | null
}) => {
  const logoUrl = logoFile?.url
  if (!logoUrl) {
    return null
  }

  return (
    <Stack
      justify="center"
      align={DesignStudioParametersToolkit.getCssVariableLiteralName(
        logoAlignCSSVariable
      )}
      px={DesignStudioParametersToolkit.getCssVariableLiteralName(
        paddingInlineCSSVariable
      )}
    >
      <img
        className={CommunicationStudioClasses.LOGO}
        src={logoUrl}
        alt={`${companyName}-logo`}
      />
    </Stack>
  )
}
